import React, { useEffect, useState } from "react"

import WorkZone from "../WorkZone/WorkZone"
// import ProdSelection from "../ProdSelection/ProdSelection"

import ToggleProductContainer from "../ToggleProduct/ToggleProductContainer/ToggleProductContainer"
import LeftPanelContainer from "../LeftPanel/LeftPanelContainer/LeftPanelContainer"
import LeftWorkAreaContainer from "../LeftWorkArea/LeftWorkAreaContainer/LeftWorkAreaContainer"
import RightWorkArea from "../RightWorkArea/RightWorkArea"

import RightPanel from "../RightPanel/RightPanel"
import Footer from "../MobileView/Footer"

import "./body.scss"
import useWindowSize from "../../hooks/useWindowSize"
import { useSelector } from "react-redux"
import { ToggleProduct } from "../MobileView/ToggleProduct"

/**
 * Body component its a container for ui components
 * @component
 * @example
 * return <Body/>
 *
 */
const Body = () => {

  const isMediaQuery = window.matchMedia('(max-width: 450px)').matches;
  const [isMobileViewOpen, setMobileViewOpen] = useState(isMediaQuery)

  const windowSize = useWindowSize()

  useEffect(()=>{
    const isMediaQuery = window.matchMedia('(max-width: 450px)').matches;
    setMobileViewOpen(isMediaQuery);
  },[windowSize])


  return (
    <main className="bodyContainer">
      <div className="bodyWorkZone">
        <WorkZone />
        {isMobileViewOpen?<ToggleProduct/>:null}
      </div>
      {!isMobileViewOpen ? 
      <>
        <div className="bodyLeftPannel">
          <LeftPanelContainer />
        </div>
        <div className="bodyLeftWorkArea">
          <LeftWorkAreaContainer />
        </div>
        <div className="bodyRightWorkArea">
          <RightWorkArea />
        </div>

        <div className="bodyRightPannel">
          <RightPanel />
        </div>
        <div className="bodyButtons">
          <ToggleProductContainer />
        </div>
      </>
      :
      <div className="bodyFooter" style={{zIndex:100}}>
        <Footer />
      </div>}
    </main>
  )
}
export default Body
